import { contracts } from '@conversed/rest/src/contracts/index';
import { createRESTClient } from '@conversed/rest/src/index';
import { axiosInterceptAccessTokenExpiry } from '../axios/axiosIntercepted';

export const client = createRESTClient(contracts).api({
  api: axiosInterceptAccessTokenExpiry,
});
